<h2>Angaben zur Immobilie <span class="grey-subtext padding-left-10">(optional)</span></h2>

<div class="grid-container-7-3">
  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>Straße</mat-label>
    <input name="object_street" [value]="street" matInput/>
  </mat-form-field>

  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>Hausnummer</mat-label>
    <input name="object_streetNumber" [value]="streetNumber" matInput/>
  </mat-form-field>
</div>

<div class="grid-container-4-8">
  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>PLZ</mat-label>
    <input name="object_zipCode" type="tel" matInput [formControl]="zipCodeFormControl"/>
    <mat-error *ngIf="zipCodeFormControl.invalid">
      <span *ngIf="zipCodeFormControl.errors.required;else defaultError">Bitte geben Sie eine PLZ ein</span>
      <ng-template #defaultError>Bitte geben Sie eine 5-stellige PLZ ein</ng-template></mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>Ort</mat-label>
    <input name="object_city" [value]="city" matInput/>
  </mat-form-field>
</div>

<div class="grid-container-1-1">
  <mat-form-field appearance="fill" class="grid-element>">
    <mat-label>Art der Immobilie</mat-label>
    <mat-select [(value)]="objectTypeSelectedValue">
      <mat-option></mat-option>
      <mat-option *ngFor="let objectType of objectTypeOptions" [value]="objectType.value">
        {{objectType.displayName}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <input name="object_type" style="display: none" [ngModel]="objectTypeSelectedValue">


  <mat-form-field appearance="fill" class="grid-element>">
    <mat-label>Modernisierungsstand</mat-label>
    <mat-select [(value)]="modernizationStateSelectedValue">
      <mat-option></mat-option>
      <mat-option *ngFor="let state of modernizationStateOptions" [value]="state.value">
        {{state.displayName}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <input name="object_modernization_state" style="display: none" [ngModel]="modernizationStateSelectedValue">
</div>

<div class="grid-container-1-1-1">
  <mat-form-field appearance="fill" class="grid-element" style="min-width: 5em">
    <mat-label>Baujahr</mat-label>
    <input oninput="this.value = this.value.substr(0, 4)"
           name="object_constructionYear" matInput [formControl]="constructionYearFormControl"/>
    <mat-error *ngIf="constructionYearFormControl.invalid">
      <span *ngIf="constructionYearFormControl.errors">Bitte geben Sie nur Jahreszahlen ein</span></mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>Grundstücksgröße in m²</mat-label>
    <input name="object_landSize" matInput [formControl]="landSizeFormControl"/>
    <mat-error *ngIf="landSizeFormControl.invalid">
      <span *ngIf="landSizeFormControl.errors">Bitte geben Sie nur Zahlen ein</span></mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>Wohnfläche gesamt</mat-label>
    <input name="object_completeLivingSpace" matInput [formControl]="completeLivingSpaceFormControl"/>
    <mat-error *ngIf="completeLivingSpaceFormControl.invalid">
      <span *ngIf="completeLivingSpaceFormControl.errors">Bitte geben Sie nur Zahlen ein</span></mat-error>
  </mat-form-field>
</div>
